import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ErrorBoundary } from "./components/error-boundary/error-boundary";
import { Layout } from "./components/layout/layout";
import { LoginPage } from "./features/auth/page/login-page";
import NotFoundPage from "./features/not-found/not-found-page";
import { dashboardRouter } from "./routers/app-router";
import { MODULE_ROUTE } from "./routers/module-router";
import { PermissionRoutes } from "./routers/permission-route";
import { ProtectedRoutes } from "./routers/protected-router";
import { getDefaultLandingRoute } from "./hooks/usePermission";
import CookieUtils from "./utils/cookie-utils";

const App: React.FC = () => {
  const token = CookieUtils.getCurrentUser().access_token ?? "";
  return (
    <ErrorBoundary>
      <Router>
        <Routes>
          <Route
            index
            path={MODULE_ROUTE.LOGIN}
            element={
              token !== "" ? (
                <Navigate replace to={getDefaultLandingRoute()} />
              ) : (
                <LoginPage />
              )
            }
          />
          <Route element={<Layout />}>
            <Route element={<ProtectedRoutes />}>
              <Route element={<PermissionRoutes />}>
                {dashboardRouter.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    element={route.component}
                  />
                ))}
              </Route>
            </Route>
          </Route>

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </ErrorBoundary>
  );
};

export default App;